import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import { first } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: [
    './project.component.scss',
    '../../../assets/project/css/components.scss',
    '../../../assets/project/css/tggsp.scss'
  ]
})
export class ProjectComponent implements OnInit {
  infoEmailID: string = 'info@sikhri.org';
  subscribeForm: FormGroup;
  isHandsetPortrait: boolean = false;
  activeLanguageTranslations: any = {};
  bannerClass: any ='';
  bannerImage: any ='';
  subscribeText = "Subscribing..";
  submitted = false;
  subscribed = false;
  selectedMilestone:  any;
  teamDetails: any;
  milestones: any = [
    {
      "tl-date" : "January 2025",
      "tl-date inner": "Launch of TGGSP Dictionary Site",
      "tl-description": "TGGSP launches The Guru Granth Sahib Dictionary site on the Gurpurab of Guru Gobind Singh Sahib."
    },
    {
      "tl-date" : "May 2024",
      "tl-date inner": "Completion of Antam Sanskar | Funeral Ceremony Sabads",
      "tl-description": "TGGSP releases the complete collection of Sabads (verses) associated with the Sikh Antam Sanskar or Funeral Ceremony by Sheikh Farid Ji, Guru Angad Sahib, Guru Arjan Sahib, and Bhagat Kabir Ji"
    },
    {
      "tl-date" : "January 2024",
      "tl-date inner": "Completion of Anand Sahib of Guru Amardas Sahib",
      "tl-description": "TGGSP completes the 40 Pauris (stanzas) of Anand Sahib revealed by Guru Amardas Sahib."
    },
    {
      "tl-date" : "January 2024",
      "tl-date inner": "Launch of TGGSP Site Redesign",
      "tl-description": "TGGSP releases a newly designed, user-centric, immersive platform for seekers worldwide."
    },
    {
      "tl-date" : "September 2023",
      "tl-date inner": "Completion of Anand Sanskar | Wedding Ceremony Sabads",
      "tl-description": "TGGSP releases the complete collection of Sabads (verses) associated with the Sikh Anand Sanskar or Wedding ceremony by Guru Nanak Sahib, Guru Ramdas Sahib, Guru Arjan Sahib, and Bhagat Kabir Ji."
    },
    {
      "tl-date" : "April 2023",
      "tl-date inner": "Completion of Amrit Sanskar | Initiation Ceremony Sabads",
      "tl-description": "TGGSP releases the complete collection of Sabads (verses) associated with the Sikh Amrit Sanskar or Initiation ceremonies revealed by Guru Nanak Sahib, Guru Amardas Sahib, Guru Ramdas Sahib, and Guru Arjan Sahib."
    },
    {
      "tl-date" : "March 2023",
      "tl-date inner": "Completion of Janam & Nam Sanskar | Birth & Naming Ceremony Sabads",
      "tl-description": "TGGSP releases the complete collection of Sabads (verses) associated with the Sikh Birth & Naming ceremonies revealed by Guru Arjan Sahib."
    },
    {
      "tl-date" : "June 2022",
      "tl-date inner": "Launch of Panjabi Commentaries",
      "tl-description": "TGGSP adds Panjabi commentaries to the new Sabads (verses) and/or Bani (composition)."
    },
    {
      "tl-date" : "April 2022",
      "tl-date inner": "Completion of all Compositions of Guru Teghbahadar Sahib",
      "tl-description": "TGGSP completes 59 sabads (verses) and 59 Saloks (couplets) of Guru Teghbahadar Sahib to commemorate the 400th Parkash Purab (Illumination Day) of the Ninth Sovereign."
    },
    {
      "tl-date" : "October 2021",
      "tl-date inner": "Significant Terms Added",
      "tl-description": "TGGSP adds a Significant Terms button on the website allowing users to get instant information on keywords in the Guru Granth Sahib."
    },
    {
      "tl-date" : "September 2021",
      "tl-date inner": "Videos of Monthly Sabad Releases",
      "tl-description": "TGGSP begins to add a reflection video done by a content team member on the new Sabad (verse) and/or Bani (composition) release to the monthly emails."
    },
    {
      "tl-date" : "November 2020",
      "tl-date inner": "Email of Monthly Sabad Releases",
      "tl-description": "TGGSP begins to release a monthly email with summaries every third Thursday announcing the release of new Sabads (verses) and/or Bani (composition)."
    },
    {
      "tl-date" : "September 2020",
      "tl-date inner": "Launch of app.gurugranthsahib.io",
      "tl-description": "The project website is released online to the public, sharing the complete work on Asa ki Var totaling about 300,000 words."
    },
    {
      "tl-date" : "March 2020",
      "tl-date inner": "The Guru Granth Sahib Project Launches",
      "tl-description": "The project is shared with the public, providing them with universal access to the first iteration of the first two Pauris of Asa ki Var to seek feedback on content and experience."
    },
    {
      "tl-date" : "July 2019",
      "tl-date inner": "Technical Team Recruited",
      "tl-description": "SikhRI recruits a team of professionals tasked with the execution of data capture and data visualization."
    },
    {
      "tl-date" : "March 2019",
      "tl-date inner": "Team Governance and Cadence Adopted",
      "tl-description": "Governance structure is agreed upon by the team, and an effective cadence is formally established."
    },
    {
      "tl-date" : "November 2018",
      "tl-date inner": "Test Pilot Begins",
      "tl-description": "Work on the Asa ki Var begins."
    },
    {
      "tl-date" : "September 2018",
      "tl-date inner": "Test Pilot Developed",
      "tl-description": "The project vision and details are formalized. The Subject Matter Experts (SMEs) and leads are then identified, and the project is sanctioned."
    },
    {
      "tl-date" : "June 2018",
      "tl-date inner": "Project Concept Formalized",
      "tl-description": "Over the span of several different meetings, key stakeholders come together to discuss the project vision, strategy, and timeline."
    },
  ];

  constructor(private dashboardService: DashboardService) {
    this.subscribeForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  ngOnInit(): void {
    this.fetchAllTeam();
    this.selectedMilestone  = this.milestones[0];
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  fetchAllTeam(){
    this.dashboardService
      .fetchProjectSikhTeam()
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.teamDetails = res?.value?.length ? res?.value : null;
          // console.log(this.getStrategicTeamMembers());
        },
        error: () => {
          console.log('error in fetching team');
        },
      });
  }
  
  scrollToSection(section: string): void {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  hasProjectTeamCategory(): boolean {
    return this.teamDetails?.some((item:any) => item.Category == 'Project');
  }

  getCoreTeamMembers(): any[] {
    return this.teamDetails?.
      filter((member: any) => member.Category === 'Core')
      .sort((a:any, b:any) => {
        const nameA = a.FirstName.toLowerCase() + ' ' + a.LastName.toLowerCase();
        const nameB = b.FirstName.toLowerCase() + ' ' + b.LastName.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
    });
  }

  getStrategicTeamMembers(): any[] {
    return this.teamDetails.filter((member: any) => member.Category === 'Strategy');
  }

  getProjectTeamMembers(): any[] {
    return this.teamDetails.filter((member: any) => member.Category === 'Project');
  }

  selectMilestone(milestone: any): void {
    this.selectedMilestone = milestone;
    this.triggerBlinkingAnimation();
  }

  triggerBlinkingAnimation(): void {
    const detailsElement = document.querySelector('.timeline-left-col-div .timeline-container-div div[role=listitem]') as HTMLElement;
    if (detailsElement) {
      detailsElement.classList.remove('fadeIn');
      void detailsElement.offsetWidth;
      detailsElement.classList.add('fadeIn');
    }
  }

  /* onSubscribe() {
    this.submitted = true;
    if(!this.subscribeForm.valid){
      return ;
    }
    if (this.subscribeForm.valid) {
      const formValue = this.subscribeForm.value;
      formValue['firstName'] = '';
      this.dashboardService.subscribeLetter(formValue).subscribe({
        next: (val) => {
          this.subscribed = true;
          this.subscribeText = "Thank you! Your submission has been received!";
          setTimeout(() => {
            this.subscribeForm.reset();
            this.subscribed = false;
            this.submitted = false;
          }, 10000);
        }, error:(err: any) => {
          this.subscribed = false;
          this.subscribeText = "Oops! Something went wrong while submitting the form.";
          console.log(err);
        }
      });
    }
  } */

}
